module.exports = __webpack_public_path__ + "static/img/chat1.c5e10c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/chat1.png
// module id = 9XOG
// module chunks = 1